import React, { ReactElement } from 'react';
import { Layout } from 'elmo-elements';

import Header from '@/pages/Module/components/Header';
import EditorLayout from '@/components/EditorLayout';

import {
  ModuleSetupRoutes,
  ModuleResourcesRoutes,
  ModuleSlideRoutes,
} from '@/pages/Module/routes';

import ModuleSlide from './Slide';
import ModuleSetup from './Setup';
import ModuleResources from './Resources';

import '../../assets/css/editor.scss';
import './Module.scss';
import { Route, Switch } from 'react-router-dom';

const ModuleView = (): ReactElement => (
  <>
    <Layout.Header>
      <Header />
    </Layout.Header>
    <EditorLayout>
      <Layout.Content>
        <div id="module-content">
          <Switch>
            <Route path={ModuleSlideRoutes.path}>
              <ModuleSlide />
            </Route>
            <Route path={ModuleSetupRoutes.path}>
              <ModuleSetup />
            </Route>
            <Route path={ModuleResourcesRoutes.path}>
              <ModuleResources />
            </Route>
          </Switch>
        </div>
      </Layout.Content>
    </EditorLayout>
  </>
);

export default ModuleView;
